/**
 * Page header (PHASE1 §7.1). Sticky h-14 blur topbar per DESIGN.md §3.4: small
 * bold title, optional inline subtitle after a "·" separator (≥sm only), and a
 * right-aligned actions slot.
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-slate-100 bg-white/90 px-4 backdrop-blur-xl sm:px-6 dark:border-slate-800/70 dark:bg-slate-950/90">
      <div className="flex min-w-0 items-baseline">
        <h1 className="truncate text-sm font-semibold text-slate-900 dark:text-slate-100">
          {title}
        </h1>
        {subtitle ? (
          <>
            <span
              aria-hidden="true"
              className="mx-1.5 hidden shrink-0 text-slate-300 sm:inline dark:text-slate-600"
            >
              ·
            </span>
            <p className="hidden min-w-0 truncate text-xs text-slate-400 sm:block dark:text-slate-500">
              {subtitle}
            </p>
          </>
        ) : null}
      </div>
      {actions ? <div className="ml-auto flex shrink-0 items-center gap-2">{actions}</div> : null}
    </header>
  );
}
